<template>
    <KTeamMemberCard
        v-editable="blok"
        :name="blok.name"
        :role="blok.role"
        :text="blok.description"
        :collapsible="Boolean(blok.description)"
    >
        <template
            v-if="blok.photo?.filename"
            #media
        >
            <NuxtImg
                :src="blok.photo.filename"
                :alt="blok.photo.alt || blok.name"
                width="72"
                height="72"
                fit="cover"
                format="auto"
                loading="lazy"
            />
        </template>
    </KTeamMemberCard>
</template>

<script setup>
import { KTeamMemberCard } from '@vemedia/karibu'

const { blok } = defineProps(['blok'])
</script>
